import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import './PaymentResultPage.css';

const PaymentPendingPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="payment-result-page pending">
            <div className="result-container">
                <div className="result-icon pending-icon">
                    <Clock size={80} strokeWidth={1.5} />
                </div>

                <h1>Pagamento Pendente</h1>
                <p className="result-message">
                    Seu pagamento está sendo processado. Você receberá uma notificação
                    assim que for confirmado.
                </p>

                <div className="result-actions">
                    <button
                        className="btn-primary"
                        onClick={() => navigate('/dashboard')}
                    >
                        Ir para Dashboard
                        <ArrowRight size={20} />
                    </button>

                    <button
                        className="btn-secondary"
                        onClick={() => navigate('/marketplace')}
                    >
                        Voltar ao Marketplace
                    </button>
                </div>

                <div className="pending-info">
                    <div className="info-box">
                        <h3>
                            <svg>...</svg>
                            O que isso significa?
                        </h3>
                        <ul>
                            <li>💳 Cartão: Aprovação em análise (até 48h)</li>
                            <li>🏦 Boleto: Aguardando compensação (até 3 dias úteis)</li>
                            <li>📱 Pix: Processamento em andamento (até 24h)</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentPendingPage;